
import { useI18next } from 'gatsby-plugin-react-i18next';
import React from 'react';
import styled from "styled-components";


const StyledUl = styled.ul`
list-style-type: none;
margin: 0;
padding: 0;
font-size: 14px;
`;

const StyledLi = styled.li`
position: relative;
`;

const Dropbtn = styled.div`
display: flex;
align-items: center;
justify-content: center;
color: #1a1a1a;
font-weight: 600;
font-size: 13px;
letter-spacing: 0.5px;
text-decoration: none;
height: 40px;
padding: 0 16px;
box-sizing: border-box;
border: 1px solid rgba(0, 0, 0, 0.12);
border-radius: 999px;
background-color: transparent;
transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
`;

const DropDownContent = styled.div`
display: none;
position: absolute;
top: 100%;
right: 0;
margin-top: 6px;
background-color: #ffffff;
min-width: 70px;
padding: 6px;
box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
border: 1px solid rgba(0, 0, 0, 0.06);
border-radius: 10px;
z-index: 1;

&::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 0;
  right: 0;
  height: 6px;
}
`;

const DropDownLi = styled(StyledLi)`
display: inline-block;
list-style-type: none;
margin: 0;
&:hover {
  cursor: pointer;
}
&:hover ${Dropbtn} {
  background-color: rgba(79, 188, 97, 0.12);
  border-color: rgba(79, 188, 97, 0.4);
  color: #4FBC61;
}
&:hover ${DropDownContent} {
  display: block;
}
`;

const SubA = styled.a`
color: #1a1a1a;
font-weight: 500;
padding: 8px 12px;
text-decoration: none;
display: block;
text-align: left;
border-radius: 6px;
cursor: pointer;
&:hover {
  background-color: rgba(79, 188, 97, 0.12);
  color: #4FBC61;
}
`;

const LanguageSelectorComponent = () => {
  const { language, languages, changeLanguage } = useI18next();

  const changeLang = (lang) => {
    changeLanguage(lang);
  }

  return (
    <React.Fragment >
      <StyledUl>
        <DropDownLi>
          <Dropbtn>
            {language.toUpperCase()}
          </Dropbtn>
          <DropDownContent>
            {languages.map(lng => (
              <span key={lng}>
                {lng === language ? (<></>) : (<SubA onClick={() => changeLang(lng)}>
                  {lng.toUpperCase()}
                </SubA>)}
              </span>
            ))}
          </DropDownContent>
        </DropDownLi>
      </StyledUl>
    </React.Fragment>
  )
}


export default LanguageSelectorComponent;